@if (form()) {
  <div class="flex-column" style="padding-bottom: 1rem">
    <div class="flex-row align-center mat-h2 gap-sm">
      Prüfregeln
      @for (action of actions(); track action.controlAction) {
        <lib-dynamic-form-action
          [hideLabel]="true"
          [action]="action"
          (callActionFunction)="callActionFunction($event)"
        />
      }
    </div>

    <div class="flex-row align-center space-between">
      <div class="mat-h3">Kilometer-Berechnung</div>
      <lib-help-icon (click)="showHelpForDistanceCalculation()"/>
    </div>
    <mat-divider/>
    <div class="form-wrapper">
      <kpi4me-form-element
        [formControlElement]="form().controls[EFormKeys.calcType]"
        [formData]="formData.calcType()"
      />
      <kpi4me-form-element
        [formControlElement]="form().controls[EFormKeys.maxSpeed]"
        [formData]="formData.maxSpeed()"
      />
      <kpi4me-form-element
        [formControlElement]="form().controls[EFormKeys.timeDiff]"
        [formData]="formData.timeDiff()"
      />
      <kpi4me-form-element
        [formControlElement]="form().controls[EFormKeys.distanceLimit]"
        [formData]="formData.distanceLimit()"
      />
    </div>

    <div class="flex-column">
      <button [disabled]="isRecalculating()" color="warn" mat-raised-button (click)="onRecalculateTransportDistances()">
        Transportdistanzen erneut berechnen
      </button>
      @if (isRecalculating()) {
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      }
    </div>
  </div>
}
<input
  style="display: none"
  type="file"
  accept=".json"
  (change)="uploadJson($event).subscribe()"
/>

<div class="mat-h3">
  Prüfregeln Fahrten

  <button
    (click)="onConditionsExport()"
    [color]="'primary'"
    mat-raised-button
    class="import-export-button"
  >
    <span
      style="display: flex; align-items: center; justify-content: center; gap: 0.5rem"
    >
        <mat-icon
          style="display: flex;"
          class="centered"
          [svgIcon]="EsvgFiles.download"
        />
   </span>
  </button>

  <button
    (click)="onConditionsImport()"
    [color]="'primary'"
    mat-raised-button
    class="import-export-button"
  >
    <span
      style="display: flex; align-items: center; justify-content: center; gap: 0.5rem"
    >
        <mat-icon
          style="display: flex;"
          class="centered"
          [svgIcon]="EsvgFiles.upload"
        />
   </span>
  </button>
</div>

<button
  mat-raised-button
  color="accent"
  (click)="createProfile()"
  style="margin: 5px">
  Neues Profil
</button>

<button
  mat-raised-button
  color="warn"
  (click)="deleteProfile()"
  [disabled]="!isCustomProfile()"
  style="margin: 5px">
  Ausgewähltes Profil löschen
</button>

<button
  mat-raised-button
  color="primary"
  (click)="renameProfile()"
  [disabled]="!isCustomProfile()"
  style="margin: 5px">
  Ausgewähltes Profil umbenennen
</button>

<button
  mat-raised-button
  color="accent"
  (click)="duplicateProfile()"
  [disabled]="activeProfile() == null"
  style="margin: 5px">
  Ausgewähltes Profil duplizieren
</button>

<mat-list>
  @for (option of profileList(); track option.guid) {
    <div
      class="profile-row"
      [class.active]="activeProfile()?.guid === option.guid"
      (click)="setActiveProfile(option)">
      <mat-list-item>
        <mat-checkbox
          [ngModel]="option.inuse"
          [color]="'primary'"
          (ngModelChange)="toggleInuse(option)"
        />
        {{ option.profile }}
      </mat-list-item>
    </div>
  }
</mat-list>

@for (category of categoryKeys; track $index) {
  <div style="height: fit-content">
    <div class="mat-h4">{{ testruleCategoryLabels[category] }}</div>

    <button
      mat-raised-button
      color="accent"
      (click)="createTestrule(category)"
      style="margin: 5px"
      [disabled]="!isCustomProfile()"
    >
      Neue Prüfregel
    </button>

    @for (form of testrulesMap[category]; track form().guid) {
      <div
        style="background-color: var(--rule-background); cursor: pointer; margin-bottom: 5px; padding: 10px"
        (click)="selectTestrule(category, $index)"
      >
        <app-testrules-query-builder
          [(formValue)]="form"
          (formValueChanged)="onFormValueChange($event)"
          [repository]="testruleRepository"
          [(query)]="query"
          (destroy)="deleteTestrule(category, $index)"
          (duplicate)="duplicateTestrule(category, $index)"
        />
      </div>
    }
  </div>
}

<app-test-rule-settings-config-form/>

<app-condition-table
  (rowsChanged)="updateTestrules($event)"
  (repoChanged)="updateProfileList($event)"
  style="display: none"
/>


<input
  #fileUpload
  style="display: none"
  type="file"
  accept=".json"
  (change)="importConditions($event)"
/>
